import React from 'react'

export const CardexAdmin = () => {
  return (
   <>
   <section class="m-0 content" dir='rtl'>
        <div class="d-flex flex-column justify-content-start align-items-center">
                <div class="card">
                    <img src="../img/dr02.png" class="position-absolute form-img" alt="" />
                    <div class="d-flex flex-column justify-content-start card-title-container">
                        <div class="card-title text-secondary">کاردکس دارویی</div>
                        <p class="card-subtitle">ثبت کاردکس دارویی </p>
                    </div>
                    <div class="d-flex flex-column flex-md-row justify-content-between w-100">
                        <div class="custom-form-control form-group position-relative w-50">
                            <input type="text" class="form-control pr-16 my-2" placeholder="نام بیمار" />
                        </div>
                        <div class="custom-form-control form-group position-relative w-50 m-0 mx-md-3">
                            <input type="text" class="form-control pr-16 my-2" placeholder="سن" />
                        </div>
                        <div class="custom-form-control form-group position-relative w-50 m-0 me-md-3">
                            <input type="text" class="form-control pr-16 my-2" placeholder="شماره تخت" />
                        </div>
                        <div class="custom-form-control form-group position-relative w-50">
                            <input type="text" class="form-control pr-16 my-2" placeholder="نام پزشک" />
                        </div>
                    </div>
                    <div class="d-flex flex-column flex-md-row justify-content-between w-100">
                        <div class="custom-form-control form-group position-relative w-50">
                            <input type="text" class="form-control pr-16 my-2" placeholder="تاریخ عمل" />
                        </div>
                        <div class="custom-form-control form-group position-relative w-50 m-0 mx-md-3">
                            <input type="text" class="form-control pr-16 my-2" placeholder="کنترل علائم حیاتی" />
                        </div>
                        <div class="custom-form-control form-group position-relative w-50 m-0 me-md-3">
                            <input type="text" class="form-control pr-16 my-2" placeholder="تشخیص" />
                        </div>
                        <div class="custom-form-control form-group position-relative w-50">
                            <input type="text" class="form-control pr-16 my-2" placeholder="نوع عمل" />
                        </div>
                    </div>
                    <div class="d-flex flex-column flex-md-row justify-content-between w-100">
                        <div class="custom-form-control form-group position-relative w-50">
                            <input type="text" class="form-control pr-16 my-2" placeholder="رژیم غذایی" />
                        </div>
                        <div class="custom-form-control form-group position-relative w-50 m-0 mx-md-3">
                            <input type="text" class="form-control pr-16 my-2" placeholder="برادن" />
                        </div>
                        <div class="custom-form-control form-group position-relative w-50 m-0 me-md-3">
                            <input type="text" class="form-control pr-16 my-2" placeholder="مورس" />
                        </div>
                        <div class="custom-form-control form-group position-relative w-50">
                            <input type="text" class="form-control pr-16 my-2" placeholder="وزن" />
                        </div>
                    </div>
                    <div class="d-flex flex-column flex-md-row justify-content-between w-100">
                        <div class="custom-form-control form-group position-relative w-50">
                            <input type="text" class="form-control pr-16 my-2" placeholder="BP" />
                        </div>
                        <div class="custom-form-control form-group position-relative w-50 m-0 mx-md-3">
                            <input type="text" class="form-control pr-16 my-2" placeholder="PR" />
                        </div>
                        <div class="custom-form-control form-group position-relative w-50 m-0 me-md-3">
                            <input type="text" class="form-control pr-16 my-2" placeholder="T" />
                        </div>
                        <div class="custom-form-control form-group position-relative w-50">
                            <input type="text" class="form-control pr-16 my-2" placeholder="ریسک فاکتور" />
                        </div>
                    </div>
                    <div class="d-flex flex-column flex-md-row justify-content-between w-100">
                        <div class="custom-form-control form-group position-relative w-50 me-md-3">
                            <select class="form-select form-control pr-16 my-2" aria-label="Default select example">
                                <option selected>گروه خونی</option>
                                <option value="AB+">AB+</option>
                                <option value="AB-">AB-</option>
                                <option value="A+">A+</option>
                                <option value="A-">A-</option>
                                <option value="B+">B+</option>
                                <option value="B-">B-</option>
                                <option value="O+">O+</option>
                                <option value="O-">O-</option>
                            </select>
                        </div>
                        <div class="custom-form-control form-group position-relative w-50 m-0 me-md-3">
                            <input type="text" class="form-control pr-16 my-2" placeholder="جذب و دفع" />
                        </div>
                        <div class="custom-form-control form-group position-relative w-50 m-0 me-md-3">
                            <input type="text" class="form-control pr-16 my-2" placeholder="RBR" />
                        </div>
                    </div>
                    <div class="seprator my-24"></div>
                    <div class="d-flex flex-column w-100" id="parent_cardex">
                        <div class="d-flex flex-column flex-md-row justify-content-between w-100">
                            <div class="custom-form-control form-group position-relative w-25 priority m-0 me-md-3">
                                <div class="custom-form-control form-group position-relative w-100">
                                    <input type="text" class="form-control pr-16 my-2" placeholder="تاریخ و ساعت" />
                                </div>
                            </div>
                            <div class="custom-form-control form-group position-relative w-100">
                                <input type="text" class="form-control pr-16 my-2" placeholder="اقدامات پرستار" />
                            </div>
                        </div>
                        <div class="d-flex flex-column w-100" id="parent_cardex">
                            <div class="d-flex flex-column flex-md-row justify-content-between w-100">
                                <div class="custom-form-control form-group position-relative w-25 priority m-0 me-md-3">
                                    <div class="custom-form-control form-group position-relative w-100">
                                        <input type="text" class="form-control pr-16 my-2" placeholder="تاریخ و ساعت" />
                                    </div>
                                </div>
                                <div class="custom-form-control form-group position-relative w-100">
                                    <input type="text" class="form-control pr-16 my-2" placeholder="اقدامات تشخیصی" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="seprator b-16"></div>
                    <div class="d-flex flex-column flex-md-row justify-content-between w-100">
                        <div class="custom-form-control form-group position-relative w-25 priority">
                            <div class="custom-form-control form-group position-relative w-100">
                                <input type="text" class="form-control pr-16 my-2" placeholder="تاریخ و ساعت" />
                            </div>
                        </div>
                        <div class="custom-form-control form-group position-relative w-50 m-0 mx-md-3">
                            <input type="text" class="form-control pr-16 my-2" placeholder="راه مصرف" />
                        </div>
                        <div class="custom-form-control form-group position-relative w-50 me-md-3">
                            <select class="form-select form-control pr-16 my-2" aria-label="Default select example">
                                <option selected>تعداد دارو</option>
                                <option value="1">1</option>
                                <option value="2">2</option>
                                <option value="3">3</option>
                                <option value="4">4</option>
                                <option value="5">5</option>
                                <option value="6">6</option>
                                <option value="7">7</option>
                                <option value="8">8</option>
                                <option value="9">9</option>
                                <option value="10">10</option>
                            </select>
                        </div>
                        <div class="custom-form-control form-group position-relative w-50 m-0">
                            <input type="text" class="form-control pr-16 my-2" placeholder="دوز دارو" />
                        </div>
                        <div class="custom-form-control form-group position-relative w-50 m-0 mx-md-3">
                            <input type="text" class="form-control pr-16 my-2" placeholder="داروهای خوراکی" />
                        </div>
                    </div>
                    <div class="d-flex flex-column flex-md-row justify-content-between w-100">
                        <div class="custom-form-control form-group position-relative w-25 priority m-0 ">
                            <div class="custom-form-control form-group position-relative w-100">
                                <input type="text" class="form-control pr-16 my-2" placeholder="تاریخ و ساعت" />
                            </div>
                        </div>
                        <div class="custom-form-control form-group position-relative w-50 m-0 mx-md-3">
                            <input type="text" class="form-control pr-16 my-2" placeholder="راه تزریق" />
                        </div>
                        <div class="custom-form-control form-group position-relative w-50 me-md-3">
                            <select class="form-select form-control pr-16 my-2" aria-label="Default select example">
                                <option selected>مقدار تزریق</option>
                                <option value="1">1</option>
                                <option value="2">2</option>
                                <option value="3">3</option>
                                <option value="4">4</option>
                                <option value="5">5</option>
                                <option value="6">6</option>
                                <option value="7">7</option>
                                <option value="8">8</option>
                                <option value="9">9</option>
                                <option value="10">10</option>
                            </select>
                        </div>
                        <div class="custom-form-control form-group position-relative w-50 m-0">
                            <input type="text" class="form-control pr-16 my-2" placeholder="دوز دارو" />
                        </div>
                        <div class="custom-form-control form-group position-relative w-50 m-0 mx-md-3">
                            <input type="text" class="form-control pr-16 my-2" placeholder="داروهای تزریقی" />
                        </div>
                    </div>
                    <button class="custom-btn-primary t-24 form-submit p-16">
                        ثبت کاردکس دارویی
                    </button>
                </div>
            </div>
        </section>
   </>
  )
}
